import { BankAccountRegex, EmailRegex, feedbackLengthRegex, IBANRegex, numberOneRegex, NumericRegex, NumericWithDecimalRegex, PhoneNumberRegex, remarksLengthRegex, sampleProductNumberRegex, PositiveNonZeroDecimalNumberRegex, PositiveNonZeroIntegerRegex, SWIFTRegex, validationMessage, ShortAddressRegex } from "../common/common";

export const requiredValidation = {
    required: true,
    message: validationMessage.REQUIRED
}

export const numericValidation = {
    pattern: NumericRegex,
    message: validationMessage.INVALID_TEXT
}

export const phoneNumberValidation = [
    {
        pattern: PhoneNumberRegex,
        message: validationMessage.INVALID_PHONE_NUMBER
    },
]
export const numericDecimalValidation = {
    pattern: NumericWithDecimalRegex,
    message: validationMessage.INVALID_TEXT
}
export const emailValidation = [
    requiredValidation,
    {
        pattern: EmailRegex,
        message: validationMessage.INVALID_EMAIL_ADDRESS
    },
]

export const postalValidation = [
    requiredValidation,
    numericValidation,
]

export const bankAccountValidation = [
    requiredValidation,
    {
        pattern: BankAccountRegex,
        message: validationMessage.INVALID_BANK_ACCOUNT
    },
]

export const bankSWIFTCodeValidation = [
    requiredValidation,
    {
        pattern: SWIFTRegex,
        message: validationMessage.INVALID_SWIFT
    },
]
export const bankIBANCodeValidation = [
    requiredValidation,
    {
        pattern: IBANRegex,
        message: validationMessage.INVALID_IBAN
    },
]
export const referenceLengthValidation = {
    max: 70,
    message: validationMessage.REFERENCE_NUMBER_LENGTH
}


export const numericFieldValidation = [
    numericValidation,
]

export const numberOneValidation = {
    pattern: numberOneRegex,
    message: validationMessage.ONE_BOX_TEXT
}

export const samplesProductValidation = {
    pattern: sampleProductNumberRegex,
    message: validationMessage.POSS_SAMPLE_PRODUCT_INVALID_TEXT
}

export const length500Validation = {
    max: 500,
    message: validationMessage.Five_Hundered_LENGTH
}

export const maxCountRule = (maxCount = 1500, name = '') => ({
    validator: (_: any, value: number) => {
        if (value > maxCount) {
            return Promise.reject(`${name} cannot be more than ${maxCount}`);
        }
        return Promise.resolve();
    },
});


export const remarksLengthValidation = {
    pattern: remarksLengthRegex,
    message: validationMessage.EXCEPTION_REMARKS_LENGTH
}

export const feedbackLengthValidation = {
    pattern: feedbackLengthRegex,
    message: validationMessage.FEEDBACK_LENGTH
}

export const PositiveNonZeroDecimalNumberValidation = {
    pattern: PositiveNonZeroDecimalNumberRegex,
    message: validationMessage.INVALID_POSITIVE_NON_ZERO_DECIMAL_NUMBER
}

export const PositiveNonZeroIntegerValidation = {
    pattern: PositiveNonZeroIntegerRegex,
    message: validationMessage.INVALID_POSITIVE_NON_ZERO_INTEGER
}

export const ShortAddressValidation = [
    {
        pattern: ShortAddressRegex,
        message: validationMessage.INVALID_SHORT_ADDRESS
    },
]

export const ADDRESS_MAX_LENGTH = 250;

export const addressLengthValidation = {
    max: ADDRESS_MAX_LENGTH,
    message: validationMessage.ADDRESS_LENGTH
}

export const googleAddressLengthValidation = {
    max: ADDRESS_MAX_LENGTH,
    message: validationMessage.GOOGLE_ADDRESS_LENGTH
}

export const weightRequiredValidation = {
    required: true,
    message: validationMessage.WEIGHT_REQUIRED
}

export const shipperShortAddressRequiredValidation = {
    required: true,
    message: validationMessage.SHIPPER_SHORT_ADDRESS_REQUIRED
}

export const consigneeShortAddressRequiredValidation = {
    required: true,
    message: validationMessage.CONSIGNEE_SHORT_ADDRESS_REQUIRED
}